import { ApiClientWrapper } from '@spike/api-client';
import { AppointmentListItem } from '@spike/appointments-list-model';
import { getCardsOnFileByCustomersThunk } from '@spike/payments-action';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useCardsOnFile = (apiClientWrapper: ApiClientWrapper, appointments: AppointmentListItem[]): void => {
    const dispatch = useDispatch();

    const requestKey = appointments
        .map(appointment => `${appointment.marketplaceId}:${appointment.customer.id}`)
        .sort()
        .join(',');

    useEffect(() => {
        const customerIdsByMarketplace = new Map<number, Set<number>>();

        appointments.forEach(appointment => {
            const customerIds = customerIdsByMarketplace.get(appointment.marketplaceId) ?? new Set<number>();
            customerIds.add(appointment.customer.id);
            customerIdsByMarketplace.set(appointment.marketplaceId, customerIds);
        });

        customerIdsByMarketplace.forEach((customerIds, marketplaceId) => {
            dispatch(getCardsOnFileByCustomersThunk(apiClientWrapper, marketplaceId, Array.from(customerIds)));
        });
    }, [requestKey]);
};
